import axios from "axios";

import { participantGroupApiUrl } from "Constants/Constants";

const participantGroupApiClient = axios.create({
  baseURL: participantGroupApiUrl,
});

export default participantGroupApiClient;
